import { render, staticRenderFns } from "./report-permissions.vue?vue&type=template&id=a36deb12&scoped=true"
import script from "./report-permissions.vue?vue&type=script&lang=js"
export * from "./report-permissions.vue?vue&type=script&lang=js"
import style0 from "./report-permissions.vue?vue&type=style&index=0&id=a36deb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36deb12",
  null
  
)

export default component.exports